// extracted by mini-css-extract-plugin
export default {"container":"past-winners_container__nsE6y"};